module.exports = __webpack_public_path__ + "media/images/logo-fortaleza-pb-8c928b711a3841a8a86c48a34bcdce5e.png";